<template>
  <div class="product news header-90">

    <div class="product-main">
      <div class="product-conten">
        <div class="nav nav-news mobile_hide">
          <h4>{{$t("news_4")}}</h4>
          <ul>
            <li v-for="(item,index) in typeData" :key="index" :class="{active: typeId==item.id}" class="box">
              <a @click="tabtitle(item.id,item.name)">{{item.name}}</a><em class="nav-line"></em>
            </li>
          </ul>
        </div>

        <div class="news-show newsDetails-show">
          <div class="product-title">
            <router-link to="/home">{{$t("home_0")}}</router-link>
            <em>/</em>
            <router-link :to="'/news/'+data.typeId">{{typeName}}</router-link>
            <em>/</em>
            <span>{{data.title}}</span>
          </div>
           <h4 style="color:red;">{{data.title}}</h4>
           <p class="date"><span>{{$t("news_5")}}：</span>{{data.date}}</p>
          <div class="news-conten-image pc_hide" v-if="data.image || data.video">
            <img :src="data.image" alt="" v-if="data.image">
            <iframe :src="data.video" frameborder="0" width="100%" height="278" v-if="!data.image"></iframe>
          </div>
           <div class="contenText" v-html="data.content"></div>
          <div class="news-conten-image mobile_hide" v-if="data.image || data.video">
            <img :src="data.image" alt="" v-if="data.image">
            <iframe :src="data.video" frameborder="0" width="100%" height="800" v-if="!data.image"></iframe>
          </div>
          <div class="content-page">
            <div class="onPage" v-if="data.pageup && data.pageup.id">
              <div class="pageBtn">
                <router-link class="gray" :to="'/newsDetails/'+data.pageup.id">{{$t("news_6")}}</router-link>
                <i></i>
              </div>
                <div  class="text mobile_hide">
                  <span class="conten-title ">{{data.pageup.title}}</span>
                  <em class="line"  v-if="data.pageup.id && data.nextpage.id"></em>
                </div>
            </div>
            <div class="nextPage"  v-if="data.nextpage && data.nextpage.id">
                <div class="text mobile_hide">
                  <span class="conten-title">{{data.nextpage.title}}</span>
                </div>
                <div class="pageBtn">
                  <router-link class="gray" :to="'/newsDetails/'+data.nextpage.id">{{$t("news_7")}}</router-link>
                  <i></i>
                </div>
            </div>
          </div>
        </div>
        <div class="type-nav pc_hide">
          <div class="selecPopup pc_hide" @click="navPopup"><span>{{typeName}}</span> <em></em></div>
          <div class="popup-box pc_hide" v-show="hidePopup">
            <div class="popup-title">
              <span>{{typeName}}</span>
              <a class="close-btn" @click="closePopup"></a>
            </div>
            <ul>
              <li v-for="(item,index) in typeData" :key="index" :class="{active:typeId==item.id}" class="box">
                <a @click="tabtitle(item.id,item.name)">{{item.name}}</a><em ></em>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import API from "./config/api.js";
  export default {
    name: 'NewsDetails',
    data () {
      return {
        typeData:[],
        data:{},
        typeName: '',
        hidePopup:false,
        active:'active',
        typeId: 0
      }
    },
    created() {
      this.getTypeList();
    },
    methods:{
      tabtitle(value,name){
        this.$router.push({ name: 'News', params: { id: value }});
      },
      getTypeList:function(){
        this.$fetch(API.GetTypeList).then((response) => {
          if(response.code == 200){
          this.typeData = response.data;

          this.getData();
        }
      });
      },
      getData(){
        this.$fetch(API.GetWebNewMessage + this.$route.params.id).then((response) => {
          if(response.code == 200){
            this.data = response.data;
            this.typeId = response.data.typeId;
            for(let i=0;i<this.typeData.length;i++){
              if(this.typeId == this.typeData[i].id){
                this.typeName = this.typeData[i].name;
              }
            }
          }
        });
      },

      //手机菜单弹窗
      navPopup(){
        this.hidePopup= true;
        $('body').addClass('no-scroll');
      },
      closePopup(){
        this.hidePopup= false;
        $('body').removeClass('no-scroll');
      }
    },
    watch: {
      $route: {
        handler() {
          this.getTypeList();
        },
        deep: true,
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  ul{
    padding-left:0;
  }
  .product{
    width: 100%;
    height:auto;
  .top-img{
    width: 100%;
    height: 100%;
  img{
    width: 100%;
    height: 100%;
    background-size: cover;
  }
  }
  .product-main{
    width: 100%;
    height: 100%;
    background: #f9f9f9 ;
    overflow: hidden;
    padding-top: 133px;
    padding-bottom: 180px;
  }
  .product-conten{
    max-width:1400px;
    margin-left:269px;
  .product-title{
  padding-bottom:40px;
  font-size: 14px;
  letter-spacing: 1.5px;
  text-align: left;
  a{
    color: #000;
    text-decoration: underline;
  }
  .no-line{
    text-decoration:none;
    color: #9A928D;
  }
  em{
    padding: 0 4px;
  }
  span,em{
    color: #9A928D;
  }
  span{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    vertical-align: middle;
    max-width:500px;
  }
  }


  }
  .product-show{
    width: 1000px;
    height: auto;
    float: left;
    padding-left:100px;
  ul{
    padding-left: 0;
  li{
    width: calc(100% / 3) ;
    padding-right: 4%;
    float: left;
    margin-bottom: 70px;
  div{
    width: 100%;
    height: 280px;
  img{
    width: 100%;
    height: 100%;
    background-size: 100%;
  }
  }
  p{
    text-align: center;
    padding-top: 20px;
  }
  }
  }
  }
  }


  .news-show{
    width:1045px;
    height:100%;
    float: left;
    padding-left:104px;
  ul{
    padding-left:0;
  li{
    width: 100%;
    height: 278px;
    margin-bottom: 24px;
    background: #fff;
    box-sizing: border-box;
    border-radius: 20px;
    box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05);
    fload:left;
  .img{
    width: 340px;
    height: 100%;
    float: left;
  img{
    width: 100%;
    height: 100%;
    background-size: 100%;
  }
  }
  .text{
    width: calc(100% - 340px );
    float: left;
    padding: 37px 37px 22px 62px;
  .latest-news{
    height: 26px;
    line-height: 26px;
    width: 104px;
    background-color: #D00717;
  a{
    color: #fff;
    text-align: center;
    display: block;
    font-size: 14px;
    font-weight: 500;
  }
  }
  .date{
    color: #908782;
    font-size: 14px;
    font-style: italic;
    font-weight: 500;
    padding: 18px 0 6px 0;
  }
  strong{
    font-size: 17px;
  }
  .news-word{
    color: #908782;
    font-size: 16px;
    padding: 6px 0 20px 0;
  }
  }
  .more{
    float:right;
  a{
    color: #D00717;
    font-size: 16px;
  }
  }
  }
  }
  }
.newsDetails-show{
  .product-title{
    padding-bottom: 10px !important;
  }
  h4{
    font-size: 32px;
    font-weight: 500;
    letter-spacing: 2.67px;
    margin-bottom: 0;
  }
  .date{
    font-size: 18px;
    font-style: italic;
    font-weight: 500;
    padding-top: 27px;
    padding-bottom: 30px;
    letter-spacing: 0.9px;
      span{
        font-style:normal;
      }
  }
  .contenText{
    height: auto;
    width:100%;
    color: #261A16;
    font-size: 18px;
    letter-spacing: 1px;
    line-height: 32px;
    text-align: justify;
    p{
      color: #261A16;
      font-size: 18px;
      letter-spacing: 1px;
      line-height: 32px;
      text-align: justify;
    }
  }
  .img{
    width: 100%;
    height: 816px;
    background: pink;
    margin:46px 0;
  }
}
  .news-conten-image{
    width: 100%;
/*    height: 800px;*/
    margin-top:40px;
    img{
      width: 100%;
      height: 100%;
      background-size: 100%;

    }
  }
  @media (max-width:1760px){
    .product .product-conten{
      margin-left: 0;
      margin: auto;

    }
    .news-show{
      width: calc(100% - 26%);
      padding-left: 7%;
    }
  }
  @media (max-width:1560px){
    .product .product-conten{
      margin: 0 50px;
    }
  }
  @media (max-width:1080px){
    .news-show{
      width: 100%;
      padding-left: 0;
      float: none;

    }
    .product .product-main{
      padding-top: 35px !important;
    }
    .product .product-conten .product-title{
      font-size: 12px;
      letter-spacing: 1.29px;
      padding-bottom: 47px !important;
      span{
        max-width: 150px;
      }
    }
    .newsDetails-show{
       h4{
         font-size: 18px;
         font-weight: 500;
         letter-spacing: 1px;
         margin-bottom: 10px;
       }
      .date{
        font-size: 12px;
        color: #908782;
        padding-top: 0px;
        padding-bottom: 36px;
      }
      .img{
        margin: 0;
      }
       .news-conten-image{
        /* height: 285px;*/
         margin-top:0;
       }
      .contenText{
        margin-top:25px;
        font-size: 15px;
        letter-spacing: 0.5px;
        line-height: 28px;
        text-align: justify;
      }
    }

    .product .product-conten{
      padding:0;
      margin: 0;
    }


  }

</style>



// WEBPACK FOOTER //
// src/components/newsDetails.vue